<template>
  <div
    class="tw:w-full tw:rounded-lg tw:border tw:border-gray-300 tw:grid tw:grid-cols-1 tw:auto-rows-fr"
    :class="{ 'tw:lg:grid-cols-2': !singleColumn }"
  >
    <BaseLink
      v-for="(item, index) in faqItems"
      :key="item.key"
      class="tw:group tw:flex tw:items-center tw:relative tw:py-4 tw:lg:py-2 tw:min-h-[72px] tw:pl-4 tw:pr-16 tw:border-gray-300"
      :class="{
        'tw:border-b': index < faqItems.length - 1,
        'tw:lg:border-b-0': !singleColumn && index >= faqItems.length - 2,
      }"
      :href="getLocalizedUrl(item.url)"
    >
      <span class="tw:flex tw:w-full">{{ $t(item.key) }}</span>
      <ChevronRight
        class="tw:bg-blue-700 tw:group-hover:bg-blue-800 tw:fill-white tw:rounded-full tw:h-[29px] tw:w-[29px] tw:absolute tw:right-5"
      />
    </BaseLink>
  </div>
</template>
<script setup>
import { computed } from 'vue'

import ChevronRight from '@/components/icons/ChevronRight.svg?component'
import BaseLink from '@/components/BaseLink.vue'

import { useSessionValues } from '@/composables/useSessionValues'

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
  singleColumn: {
    type: Boolean,
    default: false,
  },
})

const { language } = useSessionValues()
const userLanguage = computed(() => {
  const lang = language.value
  return lang === 'en-GB' ? 'en-US' : lang
})

const faqItems = computed(() => props.items)

const getLocalizedUrl = url => {
  if (!url) return ''
  const separator = url.includes('?') ? '&' : '?'
  return `${url}${separator}language=${userLanguage.value}`
}
</script>
